import { render, staticRenderFns } from "./splashscreen.vue?vue&type=template&id=493e04bc"
var script = {}
import style0 from "./splashscreen.vue?vue&type=style&index=0&id=493e04bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports